<template>
  <drag-dialog
    :visible.sync="visible"
    :title="`${activeInfo.id ? '编辑' : '新增'}样品信息`"
    width="600px"
    height="400px"
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset('editForm')"
  >
    <el-form v-loading="detailLoading" :model="editForm" :rules="rules" ref="editForm" label-width="120px">
      <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
        <el-col :span="24">
          <el-form-item v-if="activeInfo.id" label="样品名称" prop="sampleName">
            <el-input disabled v-model="editForm.sampleName" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item v-else label="样品名称" prop="sampleId">
            <el-select v-model="editForm.sampleId" placeholder="请选择" filterable @change="sampleChage">
              <el-option v-for="item in sampleOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="计算规格" prop="calModel">
            <el-input v-model.trim="editForm.calModel" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="实际规格" prop="actModel">
            <el-input v-model.trim="editForm.actModel" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="样品单价" prop="unitPrice">
            <el-input type="number" v-model="editForm.unitPrice" placeholder="请输入" clearable>
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <template slot="footer">
      <el-button @click="$emit('update:visible', false)">关 闭</el-button>
      <el-button type="primary" @click="handleSubmit">确 认</el-button>
    </template>
  </drag-dialog>
</template>

<script>
import { getSampleList, editSamplePrice } from '@/api/system';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    activeInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      detailLoading: false,
      editForm: {},
      sampleOptions: [],
      rules: {
        sampleId: [{ required: true, message: '请选择样品名称', trigger: 'change' }],
        sampleName: [{ required: true, message: '请输入样品名称', trigger: 'blur' }],
        calModel: [{ required: true, message: '请输入计算规格', trigger: 'blur' }],
        unitPrice: [{ required: true, message: '请输入样品单价', trigger: 'blur' }]
      }
    };
  },
  computed: {},
  watch: {
    async visible(val) {
      if (val) {
        if (this.activeInfo.id) {
          this.editForm = {
            id: this.activeInfo.id,
            sampleId: this.activeInfo.sampleId,
            sampleName: this.activeInfo.sampleName,
            calModel: this.activeInfo.calModel,
            actModel: this.activeInfo.actModel,
            unitPrice: this.activeInfo.unitPrice
          };
        } else {
          const { data } = await getSampleList({ pageNum: 1, pageSize: 999 });
          this.sampleOptions = data.list.map(item => ({
            label: item.sampleName,
            value: item.id
          }));
        }
      }
    }
  },
  methods: {
    sampleChage(sampleId) {
      const sample = this.sampleOptions.find(item => item.value === sampleId);
      this.editForm.sampleName = sample.label;
    },
    handleSubmit() {
      this.$refs.editForm.validate(async valid => {
        if (valid) {
          this.submitLoading = true;

          const params = { ...this.editForm };
          try {
            await editSamplePrice(params);
            this.$emit('refresh');
            this.$emit('update:visible', false);
            this.$message.success('提交成功!');
          } finally {
            this.submitLoading = false;
          }
        }
      });
    },
    // 获取字典
    async getDictsByCode(code, dataType) {
      const { data } = await getDictsByCode({ code });
      this[dataType] = data ?? [];
    }
  },
  created() {},
  mounted() {}
};
</script>

<style scoped>
.el-select {
  width: 100%;
}

.el-button--mini.is-circle {
  padding: 5px;
}
</style>
